// extracted by mini-css-extract-plugin
export default {"container":"EmptyContent_container__D3+J1","title":"EmptyContent_title__yX05m","message":"EmptyContent_message__kpp15","illustration":"EmptyContent_illustration__H98U9"};